import { cn } from '@/lib/utils';

import type { DataTrackerSectionProps } from '@/components/atoms/Section/Section';
import Section from '@/components/atoms/Section/Section';

export type BentoWrapperProps = {
  children: React.ReactNode;
  classNames: {
    root?: string;
    innerContainer?: string;
  };
} & DataTrackerSectionProps;

export const bentoWrapperConstraintClass = 'mx-auto max-w-section-contained';

export function BentoWrapper({
  children,
  classNames,
  ...rest
}: BentoWrapperProps) {
  return (
    <Section
      {...rest}
      className={cn(
        'w-full min-w-0 px-5 md:px-9 pt-10 pb-5 md:pt-0 md:pb-15',
        'max-md:[[data-slice-header]>&]:pt-0 max-md:[[data-slice-header]>&]:-mt-3',
        classNames?.root
      )}
    >
      <div
        className={cn(
          bentoWrapperConstraintClass,
          'w-full min-w-0',
          classNames?.innerContainer
        )}
      >
        {children}
      </div>
    </Section>
  );
}
